import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';
import Link from 'next/link';

type SectionHeaderProps = {
    className?: string;
    title: string;
    description?: string;
    linkTitle: React.ReactElement | string;
    linkUrl?: string;
};

const SectionHeader = (props: SectionHeaderProps) => {
    const { title, description, linkTitle, linkUrl, className } = props;

    return (
        <div className={classNames('md:mt-0 md:flex md:justify-between md:items-center w-full px-10 py-5', className)}>
            <div className="flex justify-start items-center gap-3">
                <div className="relative">
                    <p className="text-base font-semibold uppercase text-dark">
                        {linkUrl ? (
                            <Link
                                href={linkUrl}
                                passHref
                                prefetch={false}
                                rel={linkUrl.indexOf('https://') !== -1 ? 'nofollow' : undefined}
                            >
                                <a>
                                    <>{title}</>
                                </a>
                            </Link>
                        ) : (
                            <>{title}</>
                        )}
                    </p>
                </div>
                {description && (
                    <div className="hidden md:flex justify-start items-start text-center md:text-left relative gap-2.5">
                        <p className="text-light-gray">{description}</p>
                    </div>
                )}
            </div>
            <div>
                {linkUrl && (
                    <Link
                        href={linkUrl}
                        prefetch={false}
                        passHref
                        rel={linkUrl.indexOf('https://') !== -1 ? 'nofollow' : undefined}
                    >
                        <a className="text-sm text-center md:text-left uppercase text-primary">
                            <>{linkTitle}</>
                        </a>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default SectionHeader;
